import { HttpPlatform, WithHttpPlatform } from '@water-web/types';

type AttachPlatformFn = <T>(data: T) => WithHttpPlatform<T>;

export const getAttachPlatformFn = (platform: HttpPlatform): AttachPlatformFn => {
  return (data) => ({ ...data, platform });
};
